import React from 'react';
import { Link } from 'react-router-dom'

const HowToPlay = (props) => {
    return (
        <div id="HowToPlay1" className="page1">
            <div className="wrapperMedium">
                <div className="pageTitle">
                    <a className="backButton" href="#"></a>
                    <h1>How To Play</h1>
                </div>

                <div>
                    <img style={{ width: '100%' }} src="assets/HowToPlay/HowToPlay.png" />
                </div>

                <h2>Objective:</h2>
                <p>The main goal is to form sets (three or four cards of the same rank) and runs (three or more cards in sequence of the same suit). The ultimate aim is to have as few unmatched cards as possible.</p>

                <h2>Dealing:</h2>
                <p>Gin Rummy is typically played with 2 players. Each player is dealt 10 cards if there are only two players, and 7 cards if there are more.</p>

                <h2>Melding:</h2>
                <p>Players take turns to draw and discard cards, trying to form sets and runs. When a player has a complete hand, they can "knock" to signal the end of the round.</p>

                <h2>Knocking:</h2>
                <p>To knock, a player must have a hand where the unmatched cards (deadwood) total 10 points or less. Aces are worth 1 point, face cards are worth 10, and numbered cards are worth their face value. The opponent can lay off their unmatched cards onto the knocking player's sets and runs.</p>

                <h2>Scoring:</h2>
                <p>The player who knocks scores the difference in points between their deadwood and the opponent's deadwood. If the opponent has no unmatched cards, it's called going "Gin," and the knocker is penalized.</p>

                <h2>Undercutting:</h2>
                <p>If the opponent can reduce their deadwood to fewer points than the knocker's, they score the difference and receive a 10-point bonus.</p>

                <h2>Gameplay:</h2>
                <p>The game is played over several rounds, and the first player to reach a set number of points (commonly 100) wins.</p>

                <div style={{ margin: '20px 0px' }}>-</div>
            </div>

        </div>
    )
};

export default HowToPlay;

